// src/utils/gtm.js
export function pushGTMEvent(eventName, params = {}) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...params
    });
    console.log('📤 GA Event Sent →', eventName);
  } else {
    console.warn('⚠️ window not available for dataLayer');
  }
}



// WEBPACK FOOTER //
// ./src/utils/gtm.js